// src/theme/styles/foundations/colors/colors.ts
var colors = {
  green: {
    100: "#D9F2E0",
    200: "#4FC58C",
    300: "#6EA580",
    500: "#1D8751",
    700: "#006340",
    800: "#324C38"
  },
  neutral: {
    black: "#0F0F0F",
    white: "#FFFFFF",
    100: "#FAFAFA",
    200: "#EDEDED",
    300: "#CFCFCF",
    400: "#A1A5A4",
    500: "#5F5F5F",
    600: "#393939",
    700: "#242424",
    800: "#121212"
  },
  beige: {
    100: "#F4F3F1",
    200: "#E9E8E3",
    300: "#D4D1C7"
  },
  orange: {
    500: "#F06142"
  },
  pink: {
    300: "#E8BFBA"
  },
  purple: {
    700: "#4F4A9E"
  },
  yellow: {
    100: "#F5ECD0",
    300: "#F5BA1A",
    500: "#CE9939",
    800: "#624D28"
  },
  red: {
    100: "#FFEBE9",
    200: "#FD9086",
    500: "#DA2C16",
    700: "#AB1615",
    800: "#593231"
  },
  // deprecate
  system: {
    error: "#AB1615",
    // red-700
    errorLight: "#FFEBE9",
    // red-100
    warning: "#CE9939",
    // yellow-300
    warningLight: "#F5ECD0",
    // yellow-100
    success: "#217B12",
    // green-300
    successLight: "#D9F2E0"
    // green-100
  },
  brand: {
    paypal: "#0F2F82",
    twitter: "#37BEF2",
    facebook: "#3D5792",
    pinterest: "#AF2626",
    affirm: "#01c9e5",
    google: "#dd4b39",
    dwolla: "#f07b31"
  }
};
var colors_default = colors;

export {
  colors_default
};
